/* eslint-disable max-statements */

export const HEADING_LOAD_MODEL_REQUESTED = "HEADING_WORKFLOW_EDITOR/LOAD_MODEL_REQUESTED";
export const HEADING_LOAD_MODEL_SUCCESS = "HEADING_WORKFLOW_EDITOR/LOAD_MODEL_SUCCESS";
export const HEADING_LOAD_MODEL_FAIL = "HEADING_WORKFLOW_EDITOR/LOAD_MODEL_FAIL";

export const HEADING_LOAD_ASSIGNEES_REQUESTED = "HEADING_WORKFLOW_EDITOR/HEADING_LOAD_ASSIGNEES_REQUESTED";
export const HEADING_LOAD_ASSIGNEES_SUCCESS = "HEADING_WORKFLOW_EDITOR/HEADING_LOAD_ASSIGNEES_SUCCESS"
export const HEADING_LOAD_ASSIGNEES_FAIL = "HEADING_WORKFLOW_EDITOR/HEADING_LOAD_ASSIGNEES_FAIL"

export const HEADING_SAVE_MODEL_REQUESTED = "HEADING_WORKFLOW_EDITOR/SAVE_MODEL_REQUESTED";
export const HEADING_SAVE_MODEL_SUCCESS = "HEADING_WORKFLOW_EDITOR/SAVE_MODEL_SUCCESS";
export const HEADING_SAVE_MODEL_FAIL = "HEADING_WORKFLOW_EDITOR/SAVE_MODEL_FAIL";

export const HEADING_ACTIVATE_MODEL_REQUESTED = "HEADING_WORKFLOW_EDITOR/ACTIVATE_MODEL_REQUESTED";
export const HEADING_ACTIVATE_MODEL_SUCCESS = "HEADING_WORKFLOW_EDITOR/ACTIVATE_MODEL_SUCCESS";
export const HEADING_ACTIVATE_MODEL_FAIL = "HEADING_WORKFLOW_EDITOR/ACTIVATE_MODEL_FAIL";

export default (
    state = {
        errors: [],
        hasInitialData: false,
        loading: 0,
        model: {},
        updating: 0,
        assignees: [],
        groups: []
    },
    { type, data }
) => {
    switch (type) {
        case HEADING_LOAD_MODEL_REQUESTED: {
            ++state.loading;
            return state;
        }
        case HEADING_LOAD_MODEL_SUCCESS: {
            --state.loading;
            state.hasInitialData = true;
            state.model = data;
            return state;
        }
        case HEADING_LOAD_MODEL_FAIL: {
            --state.loading;
            state.errors.push({ error: data, type });
            return state;
        }
        case HEADING_SAVE_MODEL_REQUESTED: {
            ++state.loading;
            return state;
        }
        case HEADING_SAVE_MODEL_SUCCESS: {
            --state.loading;
            state.model = data;
            return state;
        }
        case HEADING_SAVE_MODEL_FAIL: {
            --state.loading;
            state.errors.push({ error: data, type });
            return state;
        }
        case HEADING_ACTIVATE_MODEL_REQUESTED: {
            ++state.loading;
            return state;
        }
        case HEADING_ACTIVATE_MODEL_SUCCESS: {
            --state.loading;
            state.model = data;
            return state;
        }
        case HEADING_ACTIVATE_MODEL_FAIL: {
            --state.loading;
            state.errors.push({ error: data, type });
            return state;
        }
        case HEADING_LOAD_ASSIGNEES_REQUESTED: {
            ++state.loading;
            return state;
        }
        case HEADING_LOAD_ASSIGNEES_SUCCESS: {
            --state.loading;
            state.hasInitialData = true;
            state.assignees = data?.users;
            state.groups = data?.groups
            return state;
        }
        case HEADING_LOAD_ASSIGNEES_FAIL: {
            --state.loading;
            state.errors.push({ error: data, type });
            return state;
        }
        default:
            return state;
    }
};

export const requestHeadingLoadWorkflowModel = data => ({ type: HEADING_LOAD_MODEL_REQUESTED, data });
export const successHeadingLoadWorkflowModel = data => ({ type: HEADING_LOAD_MODEL_SUCCESS, data });
export const failHeadingLoadWorkflowModel = data => ({ type: HEADING_LOAD_MODEL_FAIL, data });

export const requestHeadingSaveWorkflowModel = (data, resolve, reject) => ({ type: HEADING_SAVE_MODEL_REQUESTED, data, resolve, reject });
export const successHeadingSaveWorkflowModel = data => ({ type: HEADING_SAVE_MODEL_SUCCESS, data });
export const failHeadingSaveWorkflowModel = data => ({ type: HEADING_SAVE_MODEL_FAIL, data });

export const requestHeadingActivateWorkflow = (data, resolve, reject) => ({ type: HEADING_ACTIVATE_MODEL_REQUESTED, data, resolve, reject });
export const successHeadingActivateWorkflow = data => ({ type: HEADING_ACTIVATE_MODEL_SUCCESS, data });
export const failHeadingActivateWorkflow = data => ({ type: HEADING_ACTIVATE_MODEL_FAIL, data });

export const requestHeadingAssignees = (data, resolve, reject) => ({ type: HEADING_LOAD_ASSIGNEES_REQUESTED, data, resolve, reject });
export const successHeadingAssignees = data => ({ type: HEADING_LOAD_ASSIGNEES_SUCCESS, data });
export const failHeadingAssignees = data => ({ type: HEADING_LOAD_ASSIGNEES_FAIL, data });
